import { render, staticRenderFns } from "./groupbuy.vue?vue&type=template&id=74dc870e&scoped=true"
import script from "./groupbuy.vue?vue&type=script&lang=ts"
export * from "./groupbuy.vue?vue&type=script&lang=ts"
import style0 from "./groupbuy.vue?vue&type=style&index=0&id=74dc870e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc870e",
  null
  
)

export default component.exports